import { render, staticRenderFns } from "./greenCompanies.vue?vue&type=template&id=2546369e&scoped=true&"
import script from "./greenCompanies.vue?vue&type=script&lang=js&"
export * from "./greenCompanies.vue?vue&type=script&lang=js&"
import style0 from "./greenCompanies.vue?vue&type=style&index=0&id=2546369e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546369e",
  null
  
)

export default component.exports